import * as Sentry from '@sentry/react'

import { env } from '@/env'

/** Must run before `createRoot(...).render(...)` in `main.tsx`. */
if (env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_DEPLOY_ENV,
    release: env.VITE_SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [env.VITE_API_BASE_URL],
    initialScope: {
      tags: { service: 'platform-app' },
    },
  })
}
